import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { CarrierPricings } from "../generated/schema";
import { useInvalidateCarriersQuery } from "./use-carriers-query";

export function useEditCarrierPriciings(shopId: string) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateShop = useInvalidateCarriersQuery({ shopId });

	const mutation = $api.useMutation(
		"patch",
		"/shops/{shopId}/carriers/{carrierId}/pricings/prices/{carrierId}",
	);

	return useMutation({
		onSuccess: () => {
			invalidateShop();
			successNotification();
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: ({
			pricings,
			carrierId,
		}: {
			pricings: CarrierPricings[];
			carrierId: string;
		}) => {
			return mutation.mutateAsync({
				params: { path: { shopId, carrierId } },
				body: pricings,
			});
		},
	});
}
